<template>
  <a-modal
    :visible="true"
    :footer="null"
    :width="500"
    @cancel="closeModal"
  >
    <a-row>
      <a-col :span="24" class="d-flex justify-content-center">
        <div class="pbz-font subtitle-md-medium">
          {{ modal.action === 'approve' ? $t('discount.confirmation') : $t('discount.promo_cancellation') }}
        </div>
      </a-col>
      <a-col :span="24" class="d-flex justify-content-center" style="margin: 10px 0px">
        <div class="pbz-font" style="text-align:center;">
          <template v-if="modal.action === 'approve'">
            <span v-html="$t('discount.activate_promo_description', { promotion_name: modal?.promotion_name })" />
          </template>
          <template v-else>
            <span v-html="$t('discount.cancel_promo_description', { promotion_name: modal?.promotion_name })" />
          </template>
        </div>
      </a-col>
      <div v-if="modal.action == 'reject'">
        <a-col class="pbz-font" style="margin-bottom: 10px">
          <b>{{ $t('discount.choose_reason_to_cancel') }}</b>
        </a-col>
        <a-col>
          <a-radio-group v-model="cancellation" size="large" :disabled="loadingCancel">
            <a-radio
              v-for="(reason, index) in cancellationReasons"
              :key="index"
              :value="reason.value"
              class="reason-list"
            >
              {{ reason.label }}
            </a-radio>
          </a-radio-group>
          <div v-if="cancellation === 'Alasan lain'" style="text-align: right; font-size: 11px; color: grey">
            {{ `${otherCancellation.length}/60` }}
          </div>
          <a-input
            v-if="cancellation === 'Alasan lain'"
            v-model="otherCancellation"
            :placeholder="$t('discount.write_reason')"
            :disabled="loadingCancel"
            :max-length="60"
          />
        </a-col>
      </div>
      <a-col v-if="true" :span="24" class="d-flex justify-content-center" style="margin-top: 30px">
        <a-button
          class="pbz-font"
          style="
            border: 1px solid #E00000;
            background: #E00000;
            color: #FFFFFF;
            width: 100%;
            height: auto;
            padding: .75rem;
            border-radius: 5px;
            cursor: pointer;
          "
          :disabled="loadingCancel"
          @click="submitApproval"
        >
          <div>
            {{ modal.action === 'approve' ? $t('discount.approve') : $t('discount.cancel_promo') }}
          </div>
          <div v-if="false">
            <a-icon type="loading" />
          </div>
        </a-button>
      </a-col>
      <a-col v-if="true" :span="24" class="d-flex justify-content-center align-items-center">
        <a-button
          class="pbz-font"
          style="
            color: #E00000;
            padding: .75rem;
            cursor: pointer;
            width: 100%;
            height: auto;
            border: none;
          "
          :disabled="loadingCancel"
          @click="closeModal"
        >
          {{ $t('utils.cancel') }}
        </a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
export default {
  props: {
    modal: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      cancellation: '',
      otherCancellation: '',
      loadingCancel: false,
      cancellationReasons: [
        { label: this.$t('discount.reasons.duplicate'), value: 'Promo duplikasi dengan promo lain' },
        { label: this.$t('discount.reasons.change_period'), value: 'Ingin mengubah / menghentikan periode aktif promo' },
        { label: this.$t('discount.reasons.less_benefit'), value: 'Promo terkait kurang bermanfaat' },
        { label: this.$t('discount.reasons.other'), value: 'Alasan lain' },
      ],
    }
  },
  methods: {
    submitApproval() {
      if(this.modal.action !== 'approve') {
        if(!this.cancellation || (this.cancellation === 'Alasan lain' && this.otherCancellation.trim() === '')) {
          this.$message.error(this.$t('discount.rules.reason_required'))
          return
        }
      }
      this.loadingCancel = true
      this.$emit('handleSubmit', {
        ...this.modal, 
        reason: this.cancellation === 'Alasan lain' ? this.otherCancellation : this.cancellation,
      })
    },
    closeModal() {
      this.loadingCancel = false
      this.cancellation = ''
      this.otherCancellation = ''
      this.$emit('handleShowModal', {show: false})
    },
  },
}
</script>

<style lang="scss">
.reason-list {
  display: block !important;
  width: 100%;
  margin-bottom: 12px !important;

  &:last-child {
    margin-bottom: 0 !important;
  }
}
</style>